import React from "react"
import ReactDOM from "react-dom"
import ProductStockLabel from "./component/ProductStockLabel"

export default class ProductStockLabelModule {
  constructor(elem) {
    this.elem = elem
    this.elem.label = elem.dataset.textLabel
    this.elem.endpointUrl = elem.dataset.endpointUrl
    this.elem.productId = elem.dataset.productId ?? undefined
    this.init()
    return this
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(<ProductStockLabel label={this.elem.label} productId={this.elem.productId} endpointUrl={this.elem.endpointUrl} />, this.elem)
  }
}
